import { Placeholder } from './Placeholder';

export const textPositionOf = (
    placeholder: Placeholder | undefined,
    width: number,
    height: number
) => {
    const scaledX = placeholder?.x ? (placeholder.x / 100) * width : 0;
    const scaledY = placeholder?.y ? (placeholder.y / 100) * height : 0;
    return {
        x: scaledX + (0.5 * width),
        upperY: scaledY + (0.4 * height),
        lowerY: scaledY + (0.6 * height)
    };
};